import PropTypes from 'prop-types';
import React from 'react';
import MenuSelector from './MenuSelector';

class ProjectUsers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: "All"
        };
    }

    handleUserChange = (user) => {
        this.setState({ user }, () => this.props.onUserChange(user));
    };

    render() {

        const { includeLabel, includeAll, projectUsers, selected, label, additionalOptions, disabled, disable, allLabel } = this.props;
        const options = includeAll ?
            [
                {
                    "value": "All",
                    "label": allLabel
                },
                ...additionalOptions,
                ...projectUsers
            ]
            :
            [
                ...additionalOptions,
                ...projectUsers
            ];


        return (
            <MenuSelector
                dataTest="user-selector"
                label={includeLabel ? label : null}
                selected={selected}
                disable={disable}
                disabled={disabled}
                handleChange={this.handleUserChange}
                hintWord="user"
                options={options} />
        );
    }
}

ProjectUsers.defaultProps = {
    includeLabel: true,
    selected: "All",
    label: "User",
    allLabel: "All",
    disabled: false,
    includeAll: true,
    additionalOptions: []
};

ProjectUsers.propTypes = {
    includeLabel: PropTypes.bool,
    label: PropTypes.string,
    disable: PropTypes.string,
    disabled: PropTypes.bool,
    includeAll: PropTypes.bool,
    selected: PropTypes.string,
    additionalOptions: PropTypes.array,
    onUserChange: PropTypes.func.isRequired,
    projectUsers: PropTypes.array
};

export default ProjectUsers;